/** Normalize plate segment the same way as splitLicensePlateForApi (trim, uppercase, strip spaces/hyphens). */
export function normalizeLicensePlateCharacters(value: string): string {
  return String(value ?? '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]/g, '');
}

/** True when the plate segment contains only A–Z and 0–9 after normalization. Empty is not invalid (required handles empty). */
export function isLicensePlateCharactersValid(value: string): boolean {
  const normalized = normalizeLicensePlateCharacters(value);
  if (!normalized) {
    return true;
  }
  return /^[A-Z0-9]+$/.test(normalized);
}

export const LICENSE_PLATE_CHARACTERS_INVALID_MESSAGE =
  'License plate can only contain letters and numbers.';
